<template>
  <div class="home">
    <TitleBox :title="$t('title.home')" :menus="menus" v-model="selectTab" @change="reloadList">
    </TitleBox>
    <div class="g-container">
      <BountyList ref="listDom" :tab="selectTab" />
    </div>
  </div>
</template>

<script>
import TitleBox from '@/components/TitleBox.vue';
import BountyList from '@/views/Home/BountyList.vue';
// import BountyItem from '@/views/Home/BountyItem.vue';
// import Waterfall from 'vue-waterfall-plugin';

export default {
  name: 'Home',
  components: { BountyList, TitleBox },
  data() {
    return {
      selectTab: 'uncompleted',
      menus: [
        {
          label: this.$t('home.uncompleted'),
          value: 'uncompleted',
        },
        {
          label: this.$t('home.hot'),
          value: 'hot',
        },
        {
          label: this.$t('home.completed'),
          value: 'completed',
        },
        {
          label: this.$t('home.all'),
          value: 'all',
        },
      ],
    };
  },
  methods: {
    reloadList() {
      this.$nextTick(() => {
        this.$refs.listDom.refresh();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';

  .home {
  }
</style>
